<template>
  <v-dialog v-model="show" max-width="800px">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs">
        <v-btn
          v-if="showActivator && !isAdmin"
          color="primary"
          dark
          class="mb-2"
          v-bind="attrs"
          v-on="on"
        >
          Nova reserva
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="properties"
                  no-data-text="Sem dados"
                  item-text="name"
                  item-value="id"
                  label="Empreendimento"
                  :rules="requiredRules"
                  v-model="form.property"
                  required
                  disabled
                />
                <!-- :disabled="!modeCreate" -->
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="brokers"
                  item-text="name"
                  item-value="id"
                  label="Corretor"
                  no-data-text="Sem dados"
                  :rules="requiredRules"
                  v-model="form.broker"
                  :disabled="isDisabledBroker"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :key="maskClient"
                  v-mask="maskClient"
                  v-model="form.identifierClient"
                  :rules="requiredRules"
                  label="CPF/CNPJ Cliente"
                  required
                  :disabled="!modeCreate"
                  @blur="$emit('blur-client')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.client.name"
                  label="Nome"
                  :rules="requiredRules"
                  required
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="typeBuys"
                  item-text="name"
                  item-value="id"
                  label="Tipo de Compra"
                  no-data-text="Sem dados"
                  :rules="requiredRules"
                  v-model="form.typeBuy"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="conditionPayments"
                  item-text="name"
                  item-value="id"
                  label="Pretensão de Pagamento"
                  :rules="requiredRules"
                  no-data-text="Sem dados"
                  v-model="form.conditionPayment"
                  required
                />
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="sizeApartments"
                  item-text="name"
                  item-value="id"
                  label="Tamanho da Sala"
                  no-data-text="Sem dados"
                  :rules="requiredRules"
                  v-model="form.sizeApartment"
                  required
                />
              </v-col>

              <!-- Apenas para adicionar o comprovante na criação da reserva -->
              <v-col v-if="modeCreate" cols="12" sm="6" md="6">
                <v-file-input
                  v-if="isGoldAttendance"
                  v-model="form.document"
                  label="Comprovante de pagamento"
                  placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                  accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                  required
                  multiple
                  small-chips
                  :rules="fileRules"
                ></v-file-input>
              </v-col>
              <v-col v-for="(doc, index) in form.documents" :key="doc.id" cols="12" sm="6" md="6">
                <v-file-input
                  :clearable="false"
                  v-if="isGoldAttendance"
                  v-model="form.documents[index]"
                  label="Comprovante de pagamento"
                  placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                  accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                  required
                  small-chips
                  :rules="fileRules"
                ></v-file-input>
              </v-col>
                <!-- Apenas na edição da reserva para add um novo comprovante -->
              <v-col v-if="!modeCreate && form.numberLot > actualNumberLot" cols="12" sm="6" md="6">
                <v-file-input
                  v-if="isGoldAttendance"
                  v-model="form.newDocument"
                  label="Novo Comprovante de pagamento"
                  placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                  accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                  required
                  multiple
                  :rules="fileRules"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="close">Cancelar</v-btn>
        <v-btn color="blue" :disabled="!valid" text @click="validate">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import store from '@/store'
  import { isAllowedFile } from '@/utils/imageFile'

  export default {
    name: 'ReserveModal',

    props: {
      // Controla a visibilidade do diálogo (usar com .sync)
      dialog: {
        type: Boolean,
        default: false
      },
      // Objeto da reserva (usar com .sync). É o model dos campos do formulário.
      reserve: {
        type: Object,
        required: true
      },
      // Listas dos v-select
      properties: {
        type: Array,
        default: () => []
      },
      brokers: {
        type: Array,
        default: () => []
      },
      typeBuys: {
        type: Array,
        default: () => []
      },
      conditionPayments: {
        type: Array,
        default: () => []
      },
      sizeApartments: {
        type: Array,
        default: () => []
      },
      // Flags de visualização
      modeCreate: {
        type: Boolean,
        default: true
      },
      isGoldAttendance: {
        type: Boolean,
        default: false
      },
      actualNumberLot: {
        type: Number,
        default: null
      },
      // Exibe o botão padrão "Nova reserva" como ativador do diálogo
      showActivator: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      valid: true,
      requiredRules: [
        v => !!v || 'Informação obrigatória'
      ],
      fileRules: [
        v => {
          if (Array.isArray(v)) {
            if (v.length === 0) {
              return 'Informação obrigatória'
            }
          } else if (!v) {
            return 'Informação obrigatória'
          }
          return true
        },
        v => {
          let messages = []
          if (Array.isArray(v)) {
            v.forEach(file => {
              if (file && !isAllowedFile(file)) {
                messages.push('Tipos permitidos: .png .jpg .jpeg e .pdf')
              }
              if (file && (file.size >= 5242880)) {
                messages.push('Tamanho máximo de arquivo 5MB')
              }
            })
            return messages.length === 0 || messages.join(', ')
          } else if (v) {
            if (typeof v.id === 'undefined') {
              messages.push('Tamanho máximo de arquivo 5MB')
            }
            return messages.length === 0 || messages.join(', ')
          }
          return true
        }
      ]
    }),

    computed: {
      show: {
        get () {
          return this.dialog
        },
        set (value) {
          this.$emit('update:dialog', value)
        }
      },

      form: {
        get () {
          return this.reserve
        },
        set (value) {
          this.$emit('update:reserve', value)
        }
      },

      formTitle () {
        return this.modeCreate ? 'Nova reserva' : 'Editar reserva'
      },

      maskClient () {
        return this.form.identifierClient && this.form.identifierClient.length > 14 ? '##.###.###/####-##' : '###.###.###-##'
      },

      isAdmin () {
        return store.getters.user.userType !== null && store.getters.user.userType.id === 1
      },

      // isManager () {
      //   return store.getters.user.userType !== null && store.getters.user.userType.id === 3
      // },

      isDisabledBroker () {
        if (this.isAdmin) return false
        // else if (this.isManager && this.modeCreate) return false
        return true
      }
    },

    watch: {
      // cobre todos os fechamentos: botão Cancelar, ESC e clique fora do diálogo
      show (val) {
        if (!val) {
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }

          this.$emit('close')
        }
      }
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.$emit('save')
        }
      },

      close () {
        this.show = false
      }
    }
  }
</script>

<!--
  Exemplo de uso (a partir de Reserves.vue, quando for migrar):

  1) Importe e registre o componente:

     import ReserveModal from '@/components/modals/ReserveModal'

     export default {
       components: {
         ReserveModal
       }
     }

  2) Use no template, substituindo o <v-dialog> inline. Toda a lógica de API/store
     (getClientByCpfCnpj, save, close) permanece no componente pai:

     <reserve-modal
       :dialog.sync="dialog"
       :reserve.sync="reserve"
       :properties="properties"
       :brokers="brokerItems"
       :type-buys="typeBuys"
       :condition-payments="conditionPayments"
       :size-apartments="sizeApartments"
       :is-admin="isAdmin"
       :mode-create="modeCreate"
       :is-gold-attendance="isGoldAttendance"
       :actual-number-lot="actualNumberLot"
       @blur-client="getClientByCpfCnpj"
       @save="save"
       @close="close"
     />

  3) (Opcional) Ativador customizado no lugar do botão padrão "Nova reserva":

     <reserve-modal :dialog.sync="dialog" :reserve.sync="reserve" ...>
       <template v-slot:activator="{ on, attrs }">
         <v-btn color="secondary" v-bind="attrs" v-on="on">Abrir reserva</v-btn>
       </template>
     </reserve-modal>
-->



// WEBPACK FOOTER //
// src/components/modals/ReserveModal.vue